import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: React.CSSProperties;
}

const Close = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      style={style}
    >
      <g transform="matrix(1,0,0,1,-5.9998,-5.99991)">
        <path d="M16.802,6.188L12,10.99L7.202,6.193C6.916,5.93 6.48,5.938 6.209,6.209L6.157,6.267C5.932,6.547 5.949,6.959 6.209,7.219L10.99,12L6.194,16.798C5.931,17.084 5.939,17.52 6.21,17.791C6.481,18.061 6.917,18.071 7.199,17.811L12,13.01L16.798,17.807C17.084,18.07 17.52,18.062 17.791,17.791L17.843,17.733C18.068,17.453 18.051,17.041 17.791,16.781L13.01,11.999L17.807,7.202C18.07,6.916 18.062,6.48 17.791,6.209C17.52,5.939 17.084,5.929 16.802,6.189L16.802,6.188Z" />
      </g>
    </svg>
  );
};

Close.defaultProps = {
  width: '100%',
  height: '100%',
  style: {
    fill: 'currentColor',
  },
};

export default Close;
